import React, { useState } from 'react';
import { Checkbox, Tooltip } from '@mui/material';

import { RoleLevelMatrix } from './RoleLevelMatrix';

export const hasExclusion = (exclusions, roleId, levelId) =>
  exclusions.some(({ role_id, level_id }) => role_id === roleId && level_id === levelId);

export const ExclusionMatrix = ({
  structure,
  roles,
  isExcluded,
  isLocked,
  lockedTitle,
  onToggle,
}) => {
  const [pending, setPending] = useState(null);

  const toggle = (roleId, levelId, excluded) => {
    setPending({ roleId, levelId, excluded });
    onToggle(roleId, levelId, excluded)
      .catch(() => {})
      .finally(() => setPending(null));
  };

  const isChecked = (roleId, levelId) =>
    pending?.roleId === roleId && pending?.levelId === levelId
      ? pending.excluded
      : isExcluded(roleId, levelId);

  return (
    <RoleLevelMatrix
      structure={structure}
      roles={roles}
      label={`Excluded roles for ${structure.name}`}
      renderCell={(role, level) => {
        const label = `Exclude ${role.name} ${level.name}`;

        return isLocked?.(role.role_id, level.level_id) ? (
          <Tooltip title={lockedTitle}>
            <span>
              <Checkbox checked disabled inputProps={{ 'aria-label': label }} />
            </span>
          </Tooltip>
        ) : (
          <Checkbox
            checked={isChecked(role.role_id, level.level_id)}
            disabled={!!pending}
            inputProps={{ 'aria-label': label }}
            onChange={({ target: { checked } }) => toggle(role.role_id, level.level_id, checked)}
          />
        );
      }}
    />
  );
};
